import { useCallback, useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'
import { GET_FEATURE_FLAGS } from '../entities/people/service/query'

export const FeatureFlags = {
  VIEW_ADMIN_PAGE_GLIMPSE: 'view_admin_page_glimpse',
  ENABLE_LLM_TIME_ENTRIES_VALIDATION: 'enable_llm_time_entries_validation',
  ENABLE_PROJECT_VIEW_DASHBOARD: 'enable_project_view_dashboard',
  ENABLE_PROJECT_OVERVIEW_TAB: 'enable_project_overview_tab',
  GLIMPSE_SUPER_USER: 'enable_super_user_glimpse',
  ENABLE_WIP_REPORT_AI: 'enable_wip_report_ai',
}

function useFeatureFlags() {
  const { isUserLoggedIn } = useSelector(state => state.auth)
  const { data, loading, error } = useQuery(GET_FEATURE_FLAGS, { skip: !isUserLoggedIn })

  const _flags = useMemo(() => {
    return data?.getFeatureFlags?.map(flag => flag.key) || []
  }, [data])

  const _hasFeatureFlag = useCallback(key => _flags.includes(key), [_flags])

  const isEnabled = useCallback(
    flagKeySymbol => {
      if (loading) return null
      return _hasFeatureFlag(flagKeySymbol)
    },
    [_hasFeatureFlag],
  )

  return { isEnabled, userFeatureFlags: _flags, isLoading: loading, error }
}

export default useFeatureFlags
